import gql from 'graphql-tag';
import { FULL_MOMENT_FRAGMENT } from 'graphql/fragment/momentFragment';
import {
    WORLD_MAP_MARKER_FRAGMENT,
    WORLD_MAP_NO_MARKERS_FRAGMENT,
    WORLD_MAP_SET_FRAGMENT,
    WORLD_MAP_VIEW_NO_MARKERS_FRAGMENT,
    WORLD_MARKER_FRAGMENT
} from 'graphql/fragment/worldFragment';

export const WORLD_MAP_QUERY = gql`
    query WorldMap($worldMapId: String!, $token: String) {
        worldMap(worldMapId: $worldMapId, token: $token) {
            ...FWorldMapNoMarkers
            guideId
            guide {
                guideId
                title
            }
            timeCreated
            timeUpdated
            worldMapSets {
                title
                type
                imageUrl
                color
                worldMapSetId
                isVisibleOnLoad
                orderIndex
                markers {
                    worldMapMarkerId
                }
            }
        }
    }
    ${WORLD_MAP_NO_MARKERS_FRAGMENT}
`;

export const WORLD_MAP_VIEW_QUERY = gql`
    query WorldMapView(
        $worldMapId: String!
        $token: String
        $initialLoad: Boolean
        $language: String
    ) {
        worldMapView(
            worldMapId: $worldMapId
            token: $token
            initialLoad: $initialLoad
            language: $language
        ) {
            ...FWorldMapViewNoMarkers
            worldMapSets {
                title
                type
                isVisibleOnLoad
                orderIndex
                imageUrl
                color
                worldMapSetId
                markers {
                    worldMapMarkerId
                }
            }
            guide {
                guideId
                title
                availableLanguages
                language
            }
        }
    }
    ${WORLD_MAP_VIEW_NO_MARKERS_FRAGMENT}
`;

export const WORLD_MAP_INITIAL_BOUNDS_QUERY = gql`
    query WorldMapInitialBounds($worldMapId: String!, $token: String) {
        worldMap(worldMapId: $worldMapId, token: $token) {
            worldMapId
            initial {
                autoBounds {
                    topLeft {
                        lat
                        lng
                    }
                    bottomRight {
                        lat
                        lng
                    }
                    padding
                }
            }
        }
    }
`;

export const WORLD_MAP_CURRENT_USER_QUERY = gql`
    query CurrentUserWorldMaps {
        currentUserWorldMaps {
            title
            worldMapId
            customMapUrl
            timeCreated
            timeUpdated
            guide {
                guideId
                title
            }
        }
    }
`;

export const WORLD_MAP_SETS_QUERY = gql`
    query WorldMapSets($worldMapId: String!, $token: String) {
        worldMap(worldMapId: $worldMapId, token: $token) {
            worldMapId
            worldMapSets {
                ...FWorldMapSet
                markers {
                    worldMapMarkerId
                    layerTitle
                }
            }
        }
    }
    ${WORLD_MAP_SET_FRAGMENT}
`;

export const WORLD_MAP_MARKER_STORY_QUERY = gql`
    query WorldMapMarkerStory($worldMapId: String!, $token: String, $language: String) {
        worldMapView(worldMapId: $worldMapId, token: $token, language: $language) {
            worldMapId
            markers {
                ...FWorldMapMarker
                ...FWorldMarker
                worldMapSets {
                    worldMapSetId
                    title
                    ...FWorldMapSet
                }
            }
        }
    }

    ${WORLD_MAP_SET_FRAGMENT}
    ${WORLD_MAP_MARKER_FRAGMENT}
    ${WORLD_MARKER_FRAGMENT}
`;

export const WORLD_MAP_STORIES = gql`
    query WorldMapStories($worldMapId: String!, $token: String, $language: String) {
        publishedStoriesForWorldMap(worldMapId: $worldMapId, token: $token, language: $language) {
            ...FFullMoment
        }
    }
    ${FULL_MOMENT_FRAGMENT}
`;

export const WORLD_MAP_MARKER = gql`
    query WorldMapMarker($worldMapId: String!, $worldMapMarkerId: String!, $token: String) {
        worldMapMarker(
            worldMapId: $worldMapId
            worldMapMarkerId: $worldMapMarkerId
            token: $token
        ) {
            ...FWorldMapMarker
        }
    }
    ${WORLD_MAP_MARKER_FRAGMENT}
`;
